import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchActiveProducts,
  selectActiveProductsStatus,
} from "../../redux_files/activeProductsSlice";
import {
  fetchWholesaleUsers,
  selectWholesaleUsersStatus,
} from "../../redux_files/Dashboard/Wholesales/wholesaleUsersSlice";
import {
  fetchWholesaleCustomers,
  selectWholesaleCustomersStatus,
} from "../../redux_files/Dashboard/Wholesales/wholesaleCustomersSlice";
import {
  fetchWholesaleProducts,
  selectWholesaleProductsStatus,
} from "../../redux_files/Dashboard/Wholesales/wholesaleProductsSlice";

import {
  fetchPOSBranches,
  selectPOSBranchesStatus,
} from "../../redux_files/Dashboard/POSs/posBranchesSlice";
import {
  fetchPOSProducts,
  selectPOSProductsStatus,
} from "../../redux_files/Dashboard/POSs/posProductsSlice";
import {
  fetchRmsPosProducts,
  selectRmsPosProductsStatus,
} from "../../redux_files/Dashboard/POSs/rmsPosProductsSlice";
import {
  fetchItemCostCategories,
  selectitemCostCategoriesRows,
  selectitemCostCategoriesStatus,
} from "../../redux_files/Inventory/itemCostCategoriesSlice";
import {
  fetchPOSComboItems,
  selectPOSComboItemsStatus,
} from "../../redux_files/Dashboard/POSs/posComboItemsSlice";
import {
  fetchPromotionItems,
  selectPromotionItemsStatus,
} from "../../redux_files/Dashboard/POSs/promotionItemsSlice";

import { fetchUsers, selectUsersStatus } from "../../redux_files/usersSlice";

import {
  selectIsAuthenticated,
  selectUserDecoded,
} from "../../redux_files/authSlice";
import globalState from "../../utils/globalState";

function AppInitializer({ children }) {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectIsAuthenticated); // ✅ قراءة حالة الدخول
  const userDecoded = useSelector(selectUserDecoded);

  const wholesaleUsersStatus = useSelector(selectWholesaleUsersStatus);
  const wholesaleCustomersStatus = useSelector(selectWholesaleCustomersStatus);
  const wholesaleProductsStatus = useSelector(selectWholesaleProductsStatus);
  const posUsersStatus = useSelector(selectPOSBranchesStatus);
  const posProductsStatus = useSelector(selectPOSProductsStatus);
  const rmsPosProductsStatus = useSelector(selectRmsPosProductsStatus);
  const posComboItemsStatus = useSelector(selectPOSComboItemsStatus);
  const promotionItemsStatus = useSelector(selectPromotionItemsStatus);

  const itemCostCategoriesStatus = useSelector(selectitemCostCategoriesStatus);

  const usersStatus = useSelector(selectUsersStatus);

  // Initialize global state when user is authenticated
  useEffect(() => {
    if (isAuthenticated && userDecoded) {
      // Try to get user profile to initialize global state
      import("../../utils/axiosAuth").then(({ default: api }) => {
        api
          .get("/api/users/profile")
          .then((res) => {
            globalState.setCurrentUser(res.data);
          })
          .catch((err) => {
            console.error(
              "Error fetching user profile in AppInitializer:",
              err
            );
          });
      });
    }
  }, [isAuthenticated, userDecoded]);

  useEffect(() => {
    if (!isAuthenticated) return;

    if (wholesaleUsersStatus === "idle") dispatch(fetchWholesaleUsers());
    if (wholesaleCustomersStatus === "idle")
      dispatch(fetchWholesaleCustomers());
    if (wholesaleProductsStatus === "idle") dispatch(fetchWholesaleProducts());

    if (posUsersStatus === "idle") dispatch(fetchPOSBranches());
    if (posProductsStatus === "idle") dispatch(fetchPOSProducts());
    if (rmsPosProductsStatus === "idle") dispatch(fetchRmsPosProducts());
    if (posComboItemsStatus === "idle") dispatch(fetchPOSComboItems());
    if (promotionItemsStatus === "idle") dispatch(fetchPromotionItems());
    if (itemCostCategoriesStatus === "idle")
      dispatch(fetchItemCostCategories());
    if (usersStatus === "idle") dispatch(fetchUsers());
  }, [
    isAuthenticated,
    dispatch,
    wholesaleUsersStatus,
    wholesaleCustomersStatus,
    wholesaleProductsStatus,
    posUsersStatus,
    posProductsStatus,
    rmsPosProductsStatus,
    posComboItemsStatus,
    promotionItemsStatus,
    itemCostCategoriesStatus,
  ]);

  return <>{children}</>;
}

export default AppInitializer;
